export default "/images/42ecf6f88e8ed0342bf89281016a5429.avif";